import apiService from '@/services/apiService';

const actions = {
  getPartners({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('additional-info/partner', payload)
        .then((response) => {
          commit('getPartners', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`marketing/referral-partner/${payload}`)
        .then((response) => {
          commit('getPartner', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getRefferalPartners({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/referral-partner/find-with-paging', payload)
        .then((response) => {
          commit('getRefferalPartners', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getCorporatePartners({ commit }) {
    apiService.get('userapp/corporate-partner')
      .then((response) => {
        commit('getCorporatePartners', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getRefferalPartner({ commit }, payload) {
    apiService.get(`marketing/referral-partner/${payload}`)
      .then((response) => {
        commit('getRefferalPartner', response.data.data);
        resolve(response);
      })
      .catch((error) => {
        reject(error);
        console.log(error);
      });
  },
  postRefferalPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('/marketing/referral-partner', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putRefferalPartner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`marketing/referral-partner/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateStatusPartners({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('marketing/referral-partner/update-status', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delRefferalPartner({ commit }, payload) {
    apiService.delete(`marketing/referral-partner/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
